import { useGetMyVouchers } from '@/api/gen/vouchers/vouchers.gen';
import { ProfileContainer } from '@/module/profile/share/UserProfile/ProfileWidget';
import { VoucherAvailableCount } from './VoucherAvailableCount';
import { VoucherCodeInput } from './VoucherCodeInput';
export const VoucherSummarySection = () => {
  const {
    data
  } = useGetMyVouchers();
  const vouchersData = data?.data;
  const availableVoucherCount = vouchersData?.usableCount || 0;
  return <ProfileContainer className="rounded-xl" data-sentry-element="ProfileContainer" data-sentry-component="VoucherSummarySection" data-sentry-source-file="VoucherSummarySection.tsx">
      <div className="flex w-full flex-wrap items-center justify-between gap-lg px-lg py-lg mobile-lg:px-2xl">
        <VoucherAvailableCount count={availableVoucherCount} data-sentry-element="VoucherAvailableCount" data-sentry-source-file="VoucherSummarySection.tsx" />
        <VoucherCodeInput data-sentry-element="VoucherCodeInput" data-sentry-source-file="VoucherSummarySection.tsx" />
      </div>
    </ProfileContainer>;
};